module.exports = __webpack_public_path__ + "img/bluegrey.b54b940e.jpg";